module.exports = __webpack_public_path__ + "static/img/icon-4.4832ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-2/icon-4.png
// module id = n549
// module chunks = 0